import React, { useEffect, useState } from "react";
import {
  Card,
  Text,
  CardHeader,
  CardContent,
  CardTitle,
  Button,
} from "@netapp/bxp-design-system-react";
import "./Frame3.scss";
import { useLangNavigate } from "../../../../utils/langNavigation";
import { useTranslation } from "react-i18next";
import { ExternalLinkIcon } from "@netapp/bxp-style/react-icons/Navigation";
import { getContentPath, loadMarkdownContent } from "../../../../utils/contentLoader";

function Frame3() {
  const navigate = useLangNavigate();
  const { i18n, t } = useTranslation();

  // States for bulletins, certs/trust center, and resources markdown data
  const [bulletinsData, setBulletinsData] = useState({});
  const [trustData, setTrustData] = useState({});
  const [resourcesData, setResourcesData] = useState({});

  // Use one effect to fetch all three resources concurrently
  useEffect(() => {
    async function loadResources() {
      try {
        const bulletinsPath = getContentPath("/content/bulletins/_index", i18n.language);
        const certsPath = getContentPath("/content/certs/_index", i18n.language);
        const resourcesPath = getContentPath("/content/resources/_index", i18n.language);

        const [bulletinsResult, certsResult, resourcesResult] = await Promise.all([
          loadMarkdownContent(bulletinsPath),
          loadMarkdownContent(certsPath),
          loadMarkdownContent(resourcesPath),
        ]);

        setBulletinsData(bulletinsResult.frontMatter);
        setTrustData(certsResult.frontMatter);
        setResourcesData(resourcesResult.frontMatter);
      } catch (error) {
        console.error("Error loading markdown files:", error);
      }
    }
    loadResources();
  }, [i18n.language]);

  return (
    <section className="frame3" aria-labelledby="frame3-title">
      <div className="innerFrame3">
        <div className="titleFrame3">
          <h2 id="frame3-title" className="titleText3">
            {t("explore_security_resources.other")}
          </h2>
        </div>

        <div className="cardsFrame3">
          <Card className="securityCard">
            <CardHeader>
              <CardTitle className="card-title3">
                {bulletinsData.longtitle}
              </CardTitle>
            </CardHeader>
            <CardContent className="card-content3">
              <Text className="card-text3">{bulletinsData.description}</Text>
            </CardContent>
            <Button
              className="card-link3"
              variant="text"
              onClick={() => navigate("/bulletins")}
            >
              {t("view_bulletins.other")}
              <ExternalLinkIcon />
            </Button>
          </Card>

          <Card className="securityCard">
            <CardHeader>
              <CardTitle className="card-title3">{t("netapp_trust_center.other")}</CardTitle>
            </CardHeader>
            <CardContent className="card-content3">
              <Text
                className="card-text3"
                dangerouslySetInnerHTML={{ __html: trustData.description }}
              />
            </CardContent>
            <Button
              className="card-link3"
              variant="text"
              onClick={() => {
                window.location.href =
                  i18n.language === "ja"
                  ? "https://www.netapp.com/ja/responsibility/trust-center/compliance/"
                  : "https://www.netapp.com/company/trust-center/compliance/";
              }}
            >
              {t("go_to_trust_center.other")}
              <ExternalLinkIcon />
            </Button>
          </Card>

          <Card className="securityCard">
            <CardHeader>
              <CardTitle className="card-title3">{t("all_resources.other")}</CardTitle>
            </CardHeader>
            <CardContent className="card-content3">
              <Text className="card-text3">{resourcesData.description}</Text>
            </CardContent>
            <Button
              className="card-link3"
              variant="text"
              onClick={() => { navigate("/resources"); window.scrollTo(0, 0); }}
            >
              {t("browse_resources.other")}
              <ExternalLinkIcon />
            </Button>
          </Card>
        </div>
      </div>
    </section>
  );
}

export default Frame3;